import { useEffect, type ReactNode } from 'react';

export default function OverlayModal({
  isOpen,
  overlayClassName,
  contentClassName,
  onClose,
  children,
  centerVertically = false,
}: {
  isOpen: boolean;
  overlayClassName: string;
  contentClassName: string;
  onClose: () => void;
  children: ReactNode;
  centerVertically?: boolean;
}) {
  const overlayClasses = `${overlayClassName} ${isOpen ? 'on' : ''} ${centerVertically ? 'overlay--center' : ''}`.trim();

  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose]);

  return (
    <div
      className={overlayClasses}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      role="dialog"
      aria-modal="true"
      style={!isOpen ? { display: 'none' } : undefined}
    >
      <div className={contentClassName} onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
}
